import { connect } from 'react-redux';
import ParticipationInOrganizations from './ParticipationInOrganizations';
import { bindActionCreators } from 'redux';
import { selectPIO } from '../../redux/participationInOrganizations/selectors';
import { getParticipation } from '../../redux/participationInOrganizations/actions';

const mapStateToProps = (state) => ({
  data: selectPIO(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getParticipation,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(ParticipationInOrganizations);
